import { createLogger } from "$/utils/logger";

export const segmentationLogger = createLogger("Segmentation");
